export default (queryString = '') => queryString.split('?')
  .flatMap(param => param.split('&'))
  .reduce((pathParams, paramString) => {
    const params = { ...pathParams };
    const [key, value] = paramString.split('=');
    params[key] = value;
    return params;
  }, {});
